import React from "react";
import Svg from "./svg";

export default class CloseIcon extends Svg {
    render() {
        return (
            <svg
                className="next-icon"
                width="32"
                height="32"
                enableBackground="new 0 0 512 512"
                version="1.1"
                viewBox="0 0 512 512"
                xmlSpace="preserve"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink">

                <polygon
                    fill={this.props.color}
                    points="180.7,416 160,396.7 310.5,256 160,115.4 180.7,96 352,256" />
            </svg>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/svg/next.js
 **/